import { render, staticRenderFns } from "./SearchField.vue?vue&type=template&id=5fb64228"
import script from "./SearchField.vue?vue&type=script&lang=ts"
export * from "./SearchField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports